import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import AppOktaLoginWidget from '../auth/AppOktaLoginWidget';
import { buildPostLoginHandlers } from '../auth/auth-utils';
import { IdpType, AppOIDCConfig } from '../auth/types';

const LoginWidget: React.FC = () => {
  const { oktaAuth } = useOktaAuth();

  // Mock OIDC config - in a real app, this would come from your configuration
  const mockOIDCConfig: AppOIDCConfig = {
    b2bOidc: {
      issuer: import.meta.env.VITE_OKTA_ISSUER || 'https://experian-nabgdc.okta.com/oauth2/aus8d3bt9unIW4yY72p7',
      clientId: import.meta.env.VITE_OKTA_CLIENT_ID || '0oa198n3dzqR5dNfd2p8',
      redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI || 'http://localhost:4033/login/callback',
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
    },
    b2eOidc: {
      issuer: import.meta.env.VITE_OKTA_ISSUER || 'https://experian-nabgdc.okta.com/oauth2/aus8d3bt9unIW4yY72p7',
      clientId: import.meta.env.VITE_OKTA_CLIENT_ID || '0oa198n3dzqR5dNfd2p8',
      redirectUri: import.meta.env.VITE_OKTA_REDIRECT_URI || 'http://localhost:4033/login/callback',
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
    },
  };
  // 'B2E_ISSUER':JSON.stringify('https://experian.okta.com/oauth2/ausmk36oz9PZAmU1i0x7'),
  //           'B2E_CLIENT_ID':JSON.stringify('0oay9mi3qtqt78gRP0x7'),

  const handleLoginSuccess = () => {
    // Redirect to home after successful login
    window.location.href = '/home';
  };

  return (
    <div style={{ padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
      

      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h1>Welcome! Please Login</h1>
        <p>Use your Okta credentials to access the application.</p>
      </div>

      <div style={{ 
        border: '1px solid #e0e0e0', 
        borderRadius: '8px', 
        padding: '20px',
        backgroundColor: '#fafafa'
      }}>
        {/* Experian Logo inside widget */}
        <div style={{ textAlign: 'center', marginBottom: '-90px' }}>
          <img 
            src="/experian-logo-tagline-blue.png" 
            alt="Experian Logo" 
            style={{
              maxWidth: '180px',
              height: 'auto',
              marginBottom: '0px'
            }}
            onError={(e) => {
              // Fallback to base64 SVG if image not found
              e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMjAwIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjMDA0Q0I4Ii8+Cjx0ZXh0IHg9IjEwMCIgeT0iMzQiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIyMCIgZm9udC13ZWlnaHQ9ImJvbGQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5FWFBFUKLBTTA8L3RleHQ+Cjwvc3ZnPgo=';
            }}
          />
        </div>

        <AppOktaLoginWidget
          ascendSsarOIDCConfig={mockOIDCConfig}
          oktaType={IdpType.OktaGDC}
          {...buildPostLoginHandlers(oktaAuth)}
          onSuccess={handleLoginSuccess}
        />
      </div>
    </div>
  );
};

export default LoginWidget;